<template>
  <div class="page black">
    <div class="hd">
      <span class="backup iconfont iconpre actable" @click="goback">
        返回
      </span>
      <span class="title-mag">{{ title }}</span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import { lcids } from "../../libs/consts";
export default {
  props: ["title", "backto"],
  data() {
    return { lcids };
  },
  methods: {
    goback() {
      if (this.backto) this.$router.push(this.backto);
      else this.$router.go(-1);
    },
  },
};
</script>
<style src="./_layout.css" />;
